exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-module=AdditionalResources] .description{margin-right:10px;font-size:20px;color:#000}[data-module=AdditionalResources] .icon{display:inline-block}[data-module=AdditionalResources] .icon img{display:inline-block;width:11px;height:12px}[data-module=AdditionalResources] .external-link{white-space:nowrap}[data-module=AdditionalResources] .external-link .title{font-family:proxima_nova_ltlight,arial,sans-serif;font-size:20px;font-weight:300;color:#007cb0}[data-module=AdditionalResources] .button:hover{text-decoration:none}[data-module=AdditionalResources] .button .title{font-size:16px;line-height:1.13;color:#fff;text-decoration:none}[data-module=AdditionalResources] ul.resources-container li.resource-item{margin-top:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/additional-resources/styles.scss
// module id = 646
// module chunks = 0